export default __webpack_public_path__ + "static/media/video4.0fd6bd66.mp4";